export default {
    'main-menu.logout.title': 'Выход',
    'loginForm.title': 'Вход',
    'loginForm.fields.email.label': 'Email',
    'loginForm.fields.password.label': 'Пароль',
    'loginForm.buttons.login.title': 'Войти',

    'common.phrases.yes': 'Yes',
    'common.phrases.no': 'No',
    'common.autocomplete.noDataText': 'No data available',
    'common.bytes': 'Bytes',
    'common.byte': 'Byte',
    'common.kb': 'KB',
    'common.mb': 'MB',
    'common.gb': 'GB',
    'common.tb': 'TB',

    'files.errors.unableToUploadFile': 'Не удалось загрузить файл, повторите попытку'
}